export default __webpack_public_path__ + "images/0f28162fd9537cbde1e14dd7beede52f.png";